export { default as AdjustmentsOutlineIcon } from './AdjustmentsOutlineIcon';
